module.exports = __webpack_public_path__ + "static/WEDDING E&M-582-2d9e7f980cb6f213c71ae5c99eb1b4e1.jpg";